export enum AlignEnum {
  START = 'start',
  CENTER = 'center',
  END = 'end',
}
